// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__eZWWL","list":"Social_list__3LM-t"};